<h2 mat-dialog-title>Add new parameter</h2>
<form [formGroup]="parameterForm">
  <mat-dialog-content class="parameter-fields-container">
    <mat-form-field appearance="fill">
      <mat-label>Parameter</mat-label>
      <mat-select formControlName="parameter" name="parameter">
        @for (parameterName of data.parameterNames; track parameterName) {
        <mat-option [value]="parameterName">{{ parameterName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Date from</mat-label>
      <input
        matInput
        [matDatepicker]="dateFromPicker"
        formControlName="dateFrom"
        name="dateFrom"
      />
      <mat-hint>DD.MM.YYYY</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateFromPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateFromPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Date until</mat-label>
      <input
        matInput
        [matDatepicker]="dateToPicker"
        formControlName="dateTo"
        name="dateTo"
      />
      <mat-hint>DD.MM.YYYY</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateToPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateToPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Value</mat-label>
      <input matInput formControlName="value" name="value" />
      @if (parameterForm.get('value')?.hasError('pattern')) {
      <mat-error
        >Only numbers with optional comma and up to 3 decimal places are
        allowed</mat-error
      >
      } @if (parameterForm.get('value')?.hasError('maxlength')) {
      <mat-error>Max length is 10</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!parameterForm.valid"
      (click)="verifyAdding()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>
